import React from "react";
import LogUserMenu from "../components/menu/admin/LogUserMenu";

const LogUser = () => {
  return <LogUserMenu />;
};
export default LogUser;
